import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from '@huaca/ui';
import '@huaca/ui/styles.css';
import './styles.css';
import { config } from './config';
import { App } from './App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider apiBase={config.apiBase} webOrigin={config.webOrigin}>
      <App />
    </AuthProvider>
  </StrictMode>,
);
